// extracted by mini-css-extract-plugin
module.exports = {"className":"zh-TW_className__5eYZN"};